// extracted by mini-css-extract-plugin
export var altBackground = "hsbc-klir-module--altBackground--ba143";
export var phoneFrameVideo = "hsbc-klir-module--phoneFrameVideo--86626";
export var phoneFrameWrapper = "hsbc-klir-module--phoneFrameWrapper--b2459";